//Library Imports
import React, { useState } from 'react';
import { Button, Divider, Dropdown, Menu, Tag, Tooltip } from 'antd';
import { getPersonalityLogo } from 'constants/utilsStyles';
import DownAngle from 'assets/img/icons/DownAngle.svg';
import Calendar from 'assets/img/icons/EmailCalender.svg';

//Local Imports
import styled from 'styled-components';

interface IContactEmailDropdownSentEmail {
  emailsData: any;
  articleId: number;
}

const ContactEmailDropdownSentEmail: React.FC<IContactEmailDropdownSentEmail> = (props: IContactEmailDropdownSentEmail) => {
  //Props
  const { emailsData, articleId } = props;
  //   console.log(emailsData);

  //Local States
  const [ellipsisState, setEllipsistate] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const menu = () => (
    <Menu>
      <Style>
        <div
          className="email-container"
          onClick={(event: any) => {
            event.preventDefault();
          }}
        >
          <div className="email-list">
            <div className="text-style">Emails ({emailsData.length})</div>
            {Object.values(emailsData).map((item: any, index: number) => (
              <div className="email-dropdown-main-div">
                <div className="d-flex flex-row email-dropdown-data">
                  <div className="d-flex flex-column email-data">
                    <span className="email-name">{item.emailName}</span>
                    {item.emailSubject ? (
                      // <Tooltip title={item.emailSubject} overlayInnerStyle={{ width: 'auto', maxWidth: '400px' }}>
                      <div className="subject-heading">
                        <span className="subject-heading-text">Subject:</span> <span className="email-subject">{item.emailSubject}</span>
                      </div>
                    ) : // </Tooltip>
                    null}
                    <div className="last-sent">
                      <img src={Calendar} alt="" className="calendar-img" />
                      {item.lastSent}
                    </div>
                  </div>

                  <div>
                    {item.personalityName ? (
                      <Tooltip title={item.personalityName}>
                        <Tag style={{ border: 'none', margin: 0, padding: 0, background: 'none', marginRight: '14px', marginTop: '11px' }}>
                          {' '}
                          <img src={getPersonalityLogo(item.personalityName)} alt="personality" className="tag-img" />
                        </Tag>
                      </Tooltip>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                {index !== emailsData.length - 1 && (
                  <div style={{ margin: '0 24px' }}>
                    <Divider style={{ margin: '0 0', borderColor: '#ddd' }} />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </Style>
    </Menu>
  );
  return (
    <Dropdown
      overlay={menu}
      placement="right"
      trigger="click"
      getPopupContainer={() => document.querySelectorAll('.dropdown-selecter-email')[0] as HTMLElement}
      overlayClassName="dropdown-checked-by-multiple-emails"
      onVisibleChange={(visible: boolean) => {
        setIsVisible(visible);
      }}
      visible={isVisible}
    >
      <Button className="email-btn">
        {emailsData.length}
        <span className="ant-select-arrow" unselectable="on" aria-hidden="true" style={{ userSelect: 'none' }}>
          <span role="img" aria-label="down" className="anticon anticon-down ant-select-suffix">
            <img src={DownAngle} alt="" />
          </span>
        </span>
      </Button>
    </Dropdown>
  );
};

export default ContactEmailDropdownSentEmail;

const Style = styled.div`
  /* padding: 10px; */
  cursor: default;
  .email-dropdown-main-div:hover {
    background-color: #f7f7f7;
  }
  .email-data {
    padding: 8px 24px;
  }
  .email-name {
    color: #979797;
    font-family: 'Roboto';
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.3px;
  }
  .email-subject {
    color: #67696a;
    font-family: 'Roboto';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 19px;
    letter-spacing: -0.292px;
  }
  .subject-heading {
    margin-top: 4px;
  }
  .subject-heading .subject-heading-text {
    color: #67696a;
    font-family: 'Roboto';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: -0.292px;
  }
  .text-style {
    color: #565855;
    font-family: 'Roboto';
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.4px;
    padding: 24px 24px 8px;
    padding-bottom: 8px;
  }
  .last-sent {
    color: #67696a;
    font-family: 'Roboto';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.3px;
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 4px;
  }
  .tag-img {
    width: 23px;
    height: 23px;
  }
`;
